import RequestHandler from './request_handler'

export default function CsrfTokenTag(): JSX.Element {
  return (
    <>
      <input type="hidden" name="authenticity_token" value={RequestHandler.getToken()} />
    </>
  )
}
